import {styled} from '@core-ui/react-stitch';

const mobileDashboardTextLabelConstraint = {
  '@media only screen and (max-width: 460px)': {
    fontSize: '.75rem',
  },
};

const DashboardSelectContainer = styled.div(() => ({
  '& label select': mobileDashboardTextLabelConstraint,
  '& .all-size-indent select': {
    '@media only screen and (max-width: 525px)': {
      paddingLeft: '0px',
    },
  },
  '& .value-size-indent select': {
    '@media only screen and (max-width: 525px)': {
      textIndent: '0%',
    },
  },
}));

export default DashboardSelectContainer;